//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      default: null
    },
    chartTitle: {
      type: String,
      default: null
    },
    chartImg: {
      type: String,
      default: null
    },
    bottomTxt: {
      type: String,
      default: null
    }
  }
}
